import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import React, { useEffect, useState, useRef } from 'react'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'
import { useDebounce } from '../../../../hooks/useDebounce'
import { HelpIndicator } from './help-indicator'

type Props = {
  conditionKeywords: string
  onChange: (keywords: string) => any
  className?: string
}

export const SearchKeywords: React.FC<Props> = (props) => {
  const [keywords, setKeywords] = useState<string>(props.conditionKeywords)
  const [isComposing, setIsComposing] = useState(false)
  const [isSearchInputFocused, setIsSearchInputFocused] = useState(false)

  const debouncedKeywords = useDebounce(keywords, 500)
  const didMountRef = useRef(false)

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true
    } else {
      onChangeDebouceKeywords()
    }
  }, [debouncedKeywords])

  const onChangeDebouceKeywords = () => {
    if (!isComposing) props.onChange(debouncedKeywords)
  }

  const onKeyDownEnter = () => {
    props.onChange(keywords)
  }

  useEffect(() => {
    setKeywords(props.conditionKeywords)
  }, [props.conditionKeywords])

  return (
    <div
      className={
        props.className
          ? `search-keywords ${props.className}`
          : 'search-keywords'
      }
    >
      <HelpIndicator
        css={css`
          transition: opacity 0.2s ease 0s;
          opacity: ${isSearchInputFocused ? 1 : 0};
          margin-bottom: 4px;
        `}
      />
      <div
        css={css`
          position: relative;
        `}
      >
        <IcomoonIcon
          name="search"
          css={css`
            position: absolute;
            font-size: 20px;
            top: 15px;
            left: 12px;
          `}
        />
        <input
          placeholder="企業名、事業内容、タグ、代表者名、地名、法人番号などを検索"
          type="text"
          value={keywords}
          onChange={(e) => {
            setKeywords(e.target.value)
          }}
          onCompositionStart={() => setIsComposing(true)}
          onCompositionEnd={() => {
            setIsComposing(false)
            onKeyDownEnter()
          }}
          className="pl-text-field pl-input-fluid"
          css={css`
            width: 100%;
            background-color: ${colors.gray40};
            color: ${colors.text};
            font-size: 14px;
            height: 50px;
            border: 0;
            border-radius: 0;
            box-shadow: none;
            padding-left: 38px;
            &::placeholder {
              color: ${colors.textLight};
            }
            &:focus {
              box-shadow: none;
            }
          `}
          onFocus={() => setIsSearchInputFocused(true)}
          onBlur={() => setIsSearchInputFocused(false)}
        />
      </div>
    </div>
  )
}
